import { FormBuilder, FormControl, FormGroup, Validators, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash'
import { DataTable } from 'primeng/primeng';
import { AuthorizationService } from '../../../services/authorization.service';

const DROPLISTITEMS =  [
    {feature: 'UI::ManualApplication', option: { label: 'Manual Application', value: {id: 'ManualApplication'}}},
    {feature: 'UI::PostedClaimGLAdjustment', option: { label: 'Posted Claim: GL Adjustment', value: {id: 'PostedClaimGLAdjustment'}}},
    {feature: 'UI::PostedClaimReversal', option: { label: 'Posted Claim: Reversal', value: {id: 'PostedClaimReversal'}}},
    {feature: 'UI::PostedRemittanceGLAdjustment', option: { label: 'Posted Remittance: GL Adjustment', value: {id: 'PostedRemittanceGLAdjustment'}}},
    {feature: 'UI::PostedRemittanceSEIDUpdate', option: { label: 'Posted Remittance: SEID Update', value: {id: 'PostedRemittanceSEIDUpdate'}}},
    {feature: 'UI::RemittanceSplit', option: { label: 'Posted Remittance: Split', value: {id: 'RemittanceSplit'}}},
    {feature: 'UI::ReversalTransaction', option: { label: 'Transaction: Reversal', value: {id: 'ReversalTransaction'}}},
]

export const CURRENCY_PATTERN = '^[+-]?[0-9]{1,15}(?:\.[0-9]{1,2})?$'

export class EventSearchApplicationHelper {
    constructor(private authorizationService: AuthorizationService) {
    }

    public MessageFailure = 'The apply operation was not successful.';
    get options() {

        let featureSecuredOptions = [];

        for (let i in DROPLISTITEMS) {
            if (this.authorizationService.hasFeature(DROPLISTITEMS[i].feature)) {
                featureSecuredOptions.push(DROPLISTITEMS[i].option);
            }
        }

        return featureSecuredOptions;
    }

    buildApplicationForm(formBuilder: FormBuilder, pattern: string | RegExp = CURRENCY_PATTERN, callback: ValidatorFn ): FormGroup {
        return formBuilder.group({
            applyAmount: new FormControl(null, [
              Validators.required,
              Validators.pattern(pattern),
              callback,
            ]),
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/helpers/event-search.applicationHelper.ts